import styled, { css, keyframes } from 'styled-components'

import smallLoaderSvg from './loaderIconSmall.svg?component'
import mediumLoader from './loaderIconMedium.svg?component'
import largeLoader from './loaderIconLarge.svg?component'

import { ReactSvgIcon } from '../../types/react'

const spinAnimationFrames = keyframes`
  from{ transform: rotate(0); }
  to{ transform: rotate(360deg); }
`

const spinAnimation = css`
  animation: ${spinAnimationFrames} 1.5s linear infinite;
`

const withSpin = (icon: ReactSvgIcon) => styled(icon)`
  ${spinAnimation}
`

export const spinningLoaderIconsMap = {
  small: withSpin(smallLoaderSvg),
  medium: withSpin(mediumLoader),
  large: withSpin(largeLoader)
} as const

export type LoaderSize = keyof typeof spinningLoaderIconsMap
